export const evaluateMinMaxChanges = (min, max, type) => {
  const handleTwoInputsValues = (minimum, maximum) => {
    minimum = Number(minimum);
    maximum = Number(maximum);
    let defaultValues = {min: '', max: ''};

    if (!minimum && !maximum) {
      return defaultValues;
    }

    if (!minimum || !maximum) {
      if (!minimum && maximum) {
        defaultValues.max = maximum.toString();
      } else {
        defaultValues.min = minimum.toString();
      }
      return defaultValues;
    }

    defaultValues = minimum > maximum ?
      { max: minimum.toString(), min: maximum.toString() } :
      { max: maximum.toString(), min: minimum.toString() };
    return defaultValues;
  };

  const actualMin = min;
  const actualMax = max;
  return handleTwoInputsValues(actualMin, actualMax, type);
};
